import {
  MEDIA_TYPE,
  useConfigStore,
  useEnableParticipantContextMenu,
  useShouldMirrorLocalVideo,
  useTrackByParticipantId,
  useTrackMuted,
  type Participant,
} from '@cometchat/calls-sdk-core';
import clsx from 'clsx';
import { useState } from 'react';
import Avatar from '../avatar/Avatar.web';
import FrameRateIndicator from '../frame-rate-indicator/FrameRateIndicator.web';
import MoreOptionButton from '../participants/participant-item/MoreOptionButton.web';
import Label from '../shared/Label.web';
import Video from '../video/Video.web';
import './style.css';

interface TileProps {
  participant: Participant;
}

const Tile = ({ participant }: TileProps) => {
  const { name, avatar, isLocal, type, pid, ruid } = participant;
  const [isHovered, setIsHovered] = useState(false);
  const enableParticipantContextMenu = useEnableParticipantContextMenu();
  const showFrameRate = useConfigStore(state => state.showFrameRate);

  const videoTrack = useTrackByParticipantId(
    pid,
    type === 'screen-share' ? MEDIA_TYPE.SCREENSHARE : MEDIA_TYPE.VIDEO,
  );
  const muted = useTrackMuted(
    type === 'screen-share' ? MEDIA_TYPE.SCREENSHARE : MEDIA_TYPE.VIDEO,
    pid,
  );
  const shouldMirror = useShouldMirrorLocalVideo();
  return (
    <div
      className="cometchat-calls-tile-container"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}>
      {enableParticipantContextMenu && (
        <MoreOptionButton
          ruid={ruid}
          closeMenu={!isHovered}
          iconFill="var(--cometchat-calls-primary-button-icon)"
        />
      )}

      <div className="cometchat-calls-tile-content">
        <Video
          videoTrack={videoTrack?.originalTrack}
          className={clsx(
            muted
              ? 'cometchat-calls-video--fade-out'
              : 'cometchat-calls-video--fade-in',
            {
              'cometchat-calls-video--mirrored':
                isLocal && type !== 'screen-share' && shouldMirror,
              'cometchat-calls-tile-video--contain': type === 'screen-share',
            },
          )}
        />
        <div className="cometchat-calls-tile-avatar-container">
          <Avatar name={name} imageUrl={avatar} />
        </div>
        <Label participant={participant} />
        {showFrameRate && !muted && (
          <FrameRateIndicator videoTrack={videoTrack?.originalTrack} />
        )}
      </div>
    </div>
  );
};

export default Tile;
